import { Button, Modal } from '@fl/cmsch-fe-library';
import React, { FC, Fragment, memo } from 'react';
import { Ant } from 'common/ant';
import { ConnectedTable } from 'utils/tables';
import { columns } from './columns';
import { rowMapper } from './row-mapper';
import { useOtherSubjectsTabSetup } from '../../hooks/use-other-subject-tab-setup';
import { OtherSubjectsTabProps } from '../../types/other-subjects-tab-props';
import { SubjectForm } from '../subject-form';
const OtherSubjectsTableBase: FC<OtherSubjectsTabProps> = props => {
  const {
    userProfileId,
    visibleModal,
    otherSubjectOptions,
    roleOptions,
    formDataForInit,
    headerButtons,
    actionSettings,
    actionMode,
    pathnamesForRefresh,
    isFromAdminModule,
    otherSubjectsForm,
    t,
    getOtherSubjects,
    handleSubmitModal,
    handleOpenCreateModal,
    handleCloseModal,
    handleOtherSubjectsSearch,
    validateDebounced,
    otherSubjectsSelector
  } = useOtherSubjectsTabSetup(props);
  return <Fragment>
            <ConnectedTable tableId={isFromAdminModule ? 'userOtherSubjectRoles' : 'userOtherSubjectRolesProfile'} columns={columns} onFetchTableData={getOtherSubjects} rowDataPageSelector={otherSubjectsSelector} actionSettings={actionSettings} headerButtons={headerButtons} withoutVerticalScrollbar paginationPosition="both" pathnamesForRefresh={pathnamesForRefresh} lazyLoadingLimit={20} showFulltextFilter enableTableSettings enableTableUserSettings rowDataToTableRowMapper={rowMapper} highlightOnEdit emptyTableContent={isFromAdminModule ? <Button role="create" onClick={handleOpenCreateModal}>
                        {t('subject')}
                    </Button> : undefined} data-sentry-element="ConnectedTable" data-sentry-source-file="index.tsx" />
            {isFromAdminModule ? <Modal title={t(actionMode === 'create' ? 'createOtherSubjectRole' : 'editOtherSubjectRole')} visible={visibleModal === otherSubjectsForm} onCancel={handleCloseModal} footer={null}>
                    <Ant.Row>
                        <Ant.Col xs={24}>
                            <SubjectForm subjectFormType="OTHER_SUBJECT" data={formDataForInit} onCancel={handleCloseModal} onSubmit={handleSubmitModal} associationOptions={otherSubjectOptions} roleOptions={roleOptions} userProfileId={userProfileId} onAssociationSearch={handleOtherSubjectsSearch} onSyncValidate={validateDebounced} />
                        </Ant.Col>
                    </Ant.Row>
                </Modal> : undefined}
        </Fragment>;
};

/**
 * Renders the other-subjects tab table and its create/edit modal when used from admin.
 *
 * @param props Other-subject table data, selectors, refresh paths, and optional admin actions.
 * @returns The other-subjects table plus the optional subject relation modal.
 *
 * @example
 * <OtherSubjectsTable {...otherSubjectsProps} />
 */
export const OtherSubjectsTable = memo(OtherSubjectsTableBase);